import Accessibility from "../../components/UI/Accessibility";
import DayPicker from "react-day-picker";
import ContentBox from "../../components/UI/ContentBox";
import Footer from "../../components/UI/Footer";
import Menu from "../../components/UI/Menu";
import { FaCalendarAlt } from "react-icons/fa";

import {
  Container,
  DateBox,
  DateModal,
  DateText,
  DateLeft,
  DateRight,
  DateReserve,
  RoomReserve,
  RoomTitle,
  Reserve,
  ReserveTitle,
  ReserveText,
} from "./styles";

import { images, icons } from "../../constants";
import Banner from "../../components/UI/Banner";
import useApi from "../../hooks/useApi";
import { useEffect } from "react";
import { useState } from "react";
import InView from "react-intersection-observer";
import FullScreenLoading from "../../components/UI/FullScreenLoading";
import { useTheme } from "../../hooks/useTheme";

import { format, addDays, subDays } from "date-fns";
import ptBR from "date-fns/esm/locale/pt-BR/";

import Modal from "../../components/UI/Modal";
import ReadMoreButton from "../../components/UI/ReadMoreButton"

const ReserveRoom = () => {

  const [dateModal, setDateModal] = useState(false);
  const [selectDate, setSelectDate] = useState(new Date());
  const [month, setMonth] = useState(new Date());
  const [reserveDay, setReserveDay] = useState([
      {
        room:"Sala 01",
        reserve:[
          {
            period:1,
            title:"Reunião",
            applicant:"Angelo",
            status:1,
          }
        ],
      },
      {
        room:"Sala 02",
        reserve:[
          {
            period:2,
            title:"Reunião",
            applicant:"Carlos",
            status:0,
          }
        ],
      },
      {
        room:"Sala 03",
        reserve:[
        ],
      },
      {
        room:"Auditorio",
        reserve:[
          {
            period:0,
            title:"Apresentação",
            applicant:"Luciana",
            status:1,
          }
        ],
      },
    ]);

  const MONTHS = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ];
  const WEEKDAYS_LONG = [
    "Domingo",
    "Segunda",
    "Terça",
    "Quarta",
    "Quinta",
    "Sexta",
    "Sabado",
  ];
  const WEEKDAYS_SHORT = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"];

  const constructReserve = (reserve)=>{
    return <ReserveText>
      <div>
        {reserve.title}
      </div>
      <div>
        Solicitado por {reserve.applicant}
      </div>
      <div>
        Situação: {reserve.status===0?"Solicitado":"Agendado"}
      </div>
    </ReserveText>;
  }

  const handleDayClick = (day) => {
      console.log("clicou no dia");
      setSelectDate(day);
      setDateModal(false);
  };
  
  useEffect(() => {
    // eslint-disable-next-line
  }, []);

  return (
    <Container>
      {(false) && <FullScreenLoading />}
      <Menu />
      <Banner
        icon={null}
        url=""
        editorId=""
      >
        Reserva de Sala
      </Banner>
      <ContentBox>
        <DateBox>
          <DateLeft onClick={()=>{setSelectDate(subDays(selectDate,1))}}>
            {"<"}
          </DateLeft>
          <DateText onClick={()=>{setDateModal(true);}}>
              <FaCalendarAlt fontSize={22}/>
              {format(selectDate, "dd/MM/yyyy (cccc)", {locale: ptBR,})}
          </DateText>
          <DateRight onClick={()=>{setSelectDate(addDays(selectDate,1))}}>
            {">"}
          </DateRight>
        </DateBox>

        {
          reserveDay.map((room)=><DateReserve>
            <RoomTitle>
              {room.room}
            </RoomTitle>
            {
              room?.reserve?.findIndex((reserve)=>{return reserve.period===0;})>=0?
                <Reserve full={true}>
                  {constructReserve(room?.reserve.find((reserve)=>{return reserve.period===0;}))}
                </Reserve>:
                <RoomReserve>
                  <Reserve>
                    <ReserveTitle>Manhã</ReserveTitle>
                    {
                      room?.reserve?.findIndex((reserve)=>{return reserve.period===1;})>=0?
                        constructReserve(room?.reserve.find((reserve)=>{return reserve.period===1;}))
                      :
                        <ReserveText>Livre</ReserveText>
                    }
                  </Reserve>

                  <Reserve>
                    <ReserveTitle>Tarde</ReserveTitle>
                    {
                      room?.reserve?.findIndex((reserve)=>{return reserve.period===2;})>=0?
                        constructReserve(room?.reserve.find((reserve)=>{return reserve.period===2;}))
                      :
                        <ReserveText>Livre</ReserveText>
                    }
                  </Reserve>

                  <Reserve>
                    <ReserveTitle>Noite</ReserveTitle>
                    {
                      room?.reserve?.findIndex((reserve)=>{return reserve.period===3;})>=0?
                        constructReserve(room?.reserve.find((reserve)=>{return reserve.period===2;}))
                      :
                        <ReserveText>Livre</ReserveText>
                    }
                  </Reserve>

                </RoomReserve>
            }
          </DateReserve>)
        }

        <Modal open={dateModal} buttonClose={true} close={()=>{setDateModal(false)}}>
          <DateModal>
            <div>Selecione a data</div>
            <DayPicker
                      onDayClick={handleDayClick}
                      month={month}
                      onMonthChange={setMonth}
                      months={MONTHS}
                      weekdaysLong={WEEKDAYS_LONG}
                      weekdaysShort={WEEKDAYS_SHORT}
                    />
            <ReadMoreButton onClick={()=>{setMonth(new Date());}} text={"Hoje"}/>
          </DateModal>
        </Modal>
      </ContentBox>
      <Footer />
    </Container>
  );
};

export default ReserveRoom;
